import styles from './HeaderContactUs.module.css';
import { Button, Typography, Link } from '@mui/material';
import Image from 'next/image';
import amsterdam from '../../images/amsterdam.jpg';
import kerala from '../../images/kerala.jpg';
import { useMediaIsDesktop } from '@klokhuis/utilities/Media/useMediaIsDesktop';
import { useIntl } from '@klokhuis/core/Intl';
import { CommonStyles } from '@klokhuis/styles/CommonStyles';
import { PageLayout } from '@klokhuis/core/PageLayout';

export const HeaderContactUs = () => {
  const isDesktop = useMediaIsDesktop();
  const { T } = useIntl();
  return (
    <PageLayout.SectionContainer>
      <div className={styles.container}>
        <Typography className={styles.header}>{T('contact.hello')}</Typography>
        <Typography className={styles.header}>{T('TALK_TO_US')}</Typography>
      </div>

      <div className={CommonStyles.divider_1}></div>
      <div className={styles.container}>
        <div>
          <Typography
            variant={isDesktop ? 'h5' : 'h6'}
            className={CommonStyles.padding_bottom_3}
          >
            {T('contact.agent_program_question')}
          </Typography>
          <Button variant="contained" color="primary">
            {T('contact.send_message_btn')}
          </Button>
        </div>
        <div>
          <section>
            <Typography variant="h6">{T('contact.reach_someone')}</Typography>
            <Typography variant="body2">
              {T('contact.email_format')}
            </Typography>
            <Link href="mailto:freshbufferai@gmail.com" underline="hover">
              <Typography variant="caption">freshbufferai@gmail.com</Typography>
            </Link>
          </section>

          <section className={CommonStyles.margin_top_3}>
            <Typography variant="h6">{T('contact.agent_program_title')}</Typography>
            <Typography variant="body2">
              {T('contact.agent_program_body')}
            </Typography>
            <Link href="mailto:freshbufferai@gmail.com" underline="hover">
              <Typography variant="caption">freshbufferai@gmail.com</Typography>
            </Link>
          </section>
        </div>
      </div>
      <div className={CommonStyles.divider_1}></div>
      <div className={styles.addressContainer}>
        <div className={styles.column}>
          <div className={styles.columnContainer}>
            <div>
              <Typography
                variant="h2"
                className={CommonStyles.padding_bottom_3}
              >
                {T('contact.amsterdam')}
              </Typography>
            </div>

            <section>
              <Typography variant="body2">Cellostraat 44</Typography>
              <Typography variant="body2">Almere</Typography>

              <Typography variant="body2">1312 JT</Typography>
              <Link href="tel:+31068127527" underline="hover">
                <Typography variant="body2">+31 0681275271</Typography>
              </Link>
              <Link href="mailto:freshbufferai@gmail.com" underline="hover">
                <Typography variant="caption">
                  freshbufferai@gmail.com
                </Typography>
              </Link>
            </section>
          </div>
        </div>
        <div className={styles.column}>
          <Image
            src={amsterdam.src}
            width={isDesktop ? 500 : 350}
            height={isDesktop ? 300 : 200}
            alt="Amsterdam"
          />
        </div>
      </div>
      <div className={CommonStyles.divider_1}></div>
      <div className={styles.addressContainer}>
        <div className={styles.column}>
          <div className={styles.columnContainer}>
            <div>
              <Typography
                variant="h2"
                className={CommonStyles.padding_bottom_3}
              >
                {T('contact.kerala')}
              </Typography>
            </div>

            <section>
              <Typography variant="body2">Anna bhavan</Typography>
              <Typography variant="body2">Elappara - 625301</Typography>

              <Typography variant="body2">Idukki, Kerala</Typography>
              <Link href="tel:+918675407049" underline="hover">
                <Typography variant="body2">+91 8675407049</Typography>
              </Link>
              <Link href="mailto:freshbufferai@gmail.com" underline="hover">
                <Typography variant="caption">
                  freshbufferai@gmail.com
                </Typography>
              </Link>
            </section>
          </div>
        </div>
        <div className={styles.column}>
          <Image
            src={kerala.src}
            width={isDesktop ? 500 : 350}
            height={isDesktop ? 300 : 200}
            alt="Kerala"
          />
        </div>
      </div>
    </PageLayout.SectionContainer>
  );
};
